<template>
  <div>
    <Toolbar />
    <v-carousel cycle height="auto" hide-delimiters show-arrows-on-hover>
      <v-carousel-item>
        <v-card class="mx-auto">
          <v-img src="../assets/img/slider1.png" height="auto" width="auto">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-carousel-item>
      <v-carousel-item>
        <v-card class="mx-auto">
          <v-img src="../assets/img/slider2.png" height="auto" width="auto">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-carousel-item>
      <v-carousel-item>
        <v-card class="mx-auto">
          <v-img src="../assets/img/slider3.png" height="auto" width="auto">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-carousel-item>
      <v-carousel-item>
        <v-card class="mx-auto">
          <v-img src="../assets/img/slider4.png" height="auto" width="auto">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-carousel-item>
    </v-carousel>
    <div class="pa-8">
      <v-card>
        <v-container class="d-flex flex-wrap justify-space-around">
          <v-tooltip v-for="menu in menu1" :key="menu.id" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar class="mx-3" size="120" v-bind="attrs" v-on="on">
                <img :src="getImageUrl(menu.gambar)" alt="John" />
              </v-avatar>
            </template>
            <span>{{menu.nama}}</span>
          </v-tooltip>
        </v-container>
        <v-container class="d-flex flex-wrap justify-space-around">
          <v-tooltip v-for="menu in menu2" :key="menu.id" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar class="mx-3" size="120" v-bind="attrs" v-on="on">
                <img :src="getImageUrl(menu.gambar)" alt="John" />
              </v-avatar>
            </template>
            <span>{{menu.nama}}</span>
          </v-tooltip>
        </v-container>
      </v-card>
    </div>

    <div class="kategori-laris mx-4">
      <b>TAMPILAN PRODUK</b>
    </div>
    <v-container class="d-flex flex-wrap text-center">
      <v-card
        raised
        class="mx-auto my-2"
        v-for="item in items"
        :key="item.idbarang"
        max-width="150"
      >
        <v-img
          @click="detailProduct(item.idbarang)"
          :src="getImageUrl(item.gambar)"
          :lazy-src="getImageUrl('load')"
          class="mx-auto"
          width="auto"
          height="150"
          centered
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <div class="pa-2 text-left">
          <v-row>
            <v-col>
              <div class="item-title p-0">
                <b>{{item.nama_item}}</b>
              </div>
              <div class="item-price">
                <b>{{item.harga | currency}}</b>
              </div>
              <div class="item-toko">{{item.nama_toko}}</div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-container>

    <v-footer color="primary lighten-1" padless>
      <v-row justify="center" no-gutters>
        <v-col class="primary lighten-2 py-4 text-center white--text" cols="12">
          &copy; {{ new Date().getFullYear() }} —
          <strong>malldesa.com</strong>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import Toolbar from "../components/Toolbar";
// import Chat from "../components/Chat";

export default {
  components: {
    Toolbar
    // Chat
  },
  data: () => ({
    loading: false,
    dialog: false,
    menu1: [
      {
        id: 1,
        nama: "Kategori",
        gambar: "Kategori"
      },
      {
        id: 2,
        nama: "Donasi",
        gambar: "Amal"
      },
      {
        id: 3,
        nama: "Tiket Kereta",
        gambar: "tiket"
      },
      {
        id: 4,
        nama: "Tiket Pesawat",
        gambar: "tiket"
      },
      {
        id: 5,
        nama: "Tiket Bus",
        gambar: "tiket"
      }
    ],
    menu2: [
      {
        id: 6,
        nama: "Kategori",
        gambar: "Kategori"
      },
      {
        id: 7,
        nama: "Kategori",
        gambar: "Kategori"
      },
      {
        id: 8,
        nama: "Kategori",
        gambar: "Kategori"
      },
      {
        id: 9,
        nama: "Kategori",
        gambar: "Kategori"
      },
      {
        id: 10,
        nama: "Kategori",
        gambar: "Kategori"
      }
    ],
    tabs: [
      {
        id: 1,
        nama_ktg: "Rumah Tangga",
        src:
          "http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/household2"
      },
      {
        id: 5,
        nama_ktg: "Mainan",
        src:
          "http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/mainan2"
      },
      {
        id: 6,
        nama_ktg: "Kebutuhan Anak",
        src:
          "http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/babies2"
      }
    ],

    saleItem: null,
    items: [],
    pencarian: "",
    carts: 0,
    user_id: localStorage.getItem("user_id"),
    carousel: [
      {
        src:
          "../assets/img/slider1.png",
      },
      {
        src:
          "../assets/img/slider2.png",
      },
      {
        src:
          "../assets/img/slider3.png",
      },
      {
        src:
          "../assets/img/slider4.png",
      }
    ]
  }),

  mounted() {
    this.loadBarang();
    localStorage.setItem("pages", 0);
    this.redirect();
  },
  computed: {
    screen() {
      var x = screen.width;
      if (x < 600) {
        x = 200;
      } else if (600 > x < 1264) {
        x = 500;
      } else if (1264 > x < 1904) {
        x = 100;
      }

      return x;
    },
    tampilan() {
      var x = screen.width;
      if (x < 600) {
        x = 4;
      } else if (600 < x > 960) {
        x = 9;
      } else if (960 > x < 1904) {
        x = 30;
      }

      return x;
    }
  },
  methods: {
    redirect() {
      var x = screen.width;

      if (x > 1025) {
        window.location.href = "http://smart247.id/#/";
      } else if (x < 1025) {
        window.location.href = "http://m.smart247.id/#/";
      }
    },
    loadBarang() {
      fetch("http://meridinet.saebo.id:2082/Login/api/Tampil")
        .then(response => response.json())
        .then(data => {
          // this.items = data.filter(d => d.idbarang > 21);
          this.items = data;
        });
    },

    showKtg(data) {
      this.$router.push("/product");
      localStorage.setItem("pages", data.id);
    },
    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    },
    goTo(e) {
      this.$router.push(e);
    },
    detailProduct(id) {
      this.$router.push("/detail/" + id);
    },
    find(words) {
      this.$router.push("find/" + words);
    },
    click() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    }
  }
};
</script>
<style scoped>
.kategori-laris {
  font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif;
  font-size: 25px;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.item-toko {
  font-size: 80%;
  font-weight: 300;
}
.item-price {
  color: red;
  margin-bottom: 0% !important;
  font-size: 85%;
}
.item-title {
  font-size: 85%;
  width: 100%;
  height: 40px;
  overflow: hidden;
  white-space: wrap;
  text-overflow: ellipsis;
  margin-bottom: 0% !important;
}
</style>
